import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { Button } from "../../button";
import styled from 'styled-components';
var ToastButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.size.spacing.medium.value;
});
export { ToastButton };